import { gql } from '@apollo/client';
export const MARK_READ = gql`
    mutation markNotificationAsRead {
        markNotificationRead(input: {}) {
            message
        }
    }
`;

export const MARK_READ_WITH_ID = gql`
    mutation markNotificationAsRead($input: MarkNotificationReadInput!) {
        markNotificationRead(input: $input) {
            message
        }
    }
`;
